import React, { useState, useEffect } from "react";
import { getCurrentTimeObj } from "../utils";

export function useRefreshCurrentTime() {
  const [currentTimeObj, setCurrentTimeObj] = useState(getCurrentTimeObj());
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTimeObj(getCurrentTimeObj());
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return currentTimeObj;
}
